import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, ListItemIcon, useTheme } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'; // Added import

const Problem: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{
      /* Remove fixed height and justifyContent */
      // height: '100%',
      display: 'flex',
      flexDirection: 'column',
      color: theme.palette.text.primary,
      padding: 4,
      // justifyContent: 'center',
    }}>
      <Typography 
        variant="h2" 
        align="center" 
        sx={{ 
          mb: 4,
          fontWeight: 'bold',
          fontSize: { xs: '3rem', sm: '4rem', md: '5rem' },
        }}
      >
        The Problem
      </Typography>
      <Box sx={{ maxWidth: '800px', margin: '0 auto' }}>
        <List>
          {/* Updated ListItems with big numbers outside the text blocks */}
          <ListItem>
            <ListItemIcon>
              <CancelOutlinedIcon sx={{ color: theme.palette.error.main }} />
            </ListItemIcon>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemText
                primary="Human assistants cost $3k-$6k/month"
                secondary="A tightening economy has operators searching for cheaper and more efficient options"
                primaryTypographyProps={{ 
                  color: theme.palette.text.primary, 
                  fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' }, 
                  fontWeight: 'bold' 
                }}
                secondaryTypographyProps={{ 
                  color: theme.palette.text.secondary, 
                  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
                }}
              />
            </Box>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CancelOutlinedIcon sx={{ color: theme.palette.error.main }} />
            </ListItemIcon>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemText 
                primary="NAR Settlement: Compliance Burden Post-August 17, 2024" 
                secondary="Increased urgency: MLSs, brokers & agents who don't increase documentation & transparency face legal action"
                primaryTypographyProps={{ 
                  color: theme.palette.text.primary, 
                  fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' }, 
                  fontWeight: 'bold' 
                }}
                secondaryTypographyProps={{ 
                  color: theme.palette.text.secondary, 
                  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
                }}
              />
            </Box>
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <CancelOutlinedIcon sx={{ color: theme.palette.error.main }} />
            </ListItemIcon>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemText 
                primary="47% of leads unanswered. 8 hour avg response time" 
                secondary="Mortgage companies and service businesses need to reach hundreds of leads and clients daily with personalized communication at scale"
                primaryTypographyProps={{ 
                  color: theme.palette.text.primary, 
                  fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' }, 
                  fontWeight: 'bold' 
                }}
                secondaryTypographyProps={{ 
                  color: theme.palette.text.secondary, 
                  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
                }}
              />
            </Box>
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <CancelOutlinedIcon sx={{ color: theme.palette.error.main }} />
            </ListItemIcon>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemText 
                primary="Email is dead. 70% of consumers prefer text messages" 
                secondary="Only 35% of businesses offer SMS options"
                primaryTypographyProps={{ 
                  color: theme.palette.text.primary, 
                  fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' }, 
                  fontWeight: 'bold' 
                }}
                secondaryTypographyProps={{ 
                  color: theme.palette.text.secondary, 
                  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
                }}
              />
            </Box>
          </ListItem>

          {/* <ListItem>
            <ListItemIcon>
              <CancelOutlinedIcon sx={{ color: theme.palette.error.main }} />
            </ListItemIcon>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemText 
                primary="TC's overwhelmed with emails" 
                secondary="Hundreds of emails daily at small brokerages, thousands at larger firms. ~5.5 emails/day per agent to TC alone"
                primaryTypographyProps={{ 
                  color: theme.palette.text.primary, 
                  fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' }, 
                  fontWeight: 'bold' 
                }}
                secondaryTypographyProps={{ 
                  color: theme.palette.text.secondary, 
                  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
                }}
              />
            </Box>
          </ListItem> */}

          <ListItem>
            <ListItemIcon>
              <CancelOutlinedIcon sx={{ color: theme.palette.error.main }} />
            </ListItemIcon>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemText 
                primary="MLS and brokerages swamped with support and recruiting emails" 
                secondary="MLS and brokerages receive hundreds of support and recruiting emails daily"
                primaryTypographyProps={{ 
                  color: theme.palette.text.primary, 
                  fontSize: { xs: '1.3rem', sm: '1.5rem', md: '1.8rem' }, 
                  fontWeight: 'bold' 
                }}
                secondaryTypographyProps={{ 
                  color: theme.palette.text.secondary, 
                  fontSize: { xs: '1rem', sm: '1.2rem', md: '1.3rem' } 
                }}
              />
            </Box>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export default Problem;
